import { Editor } from "@tinymce/tinymce-react";
import { Button, Card, DatePicker, Image, Input, Modal, Select, Table, Tag, Tooltip } from "antd";
import { useFormik } from "formik";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { FaPlus, FaRegEye } from "react-icons/fa";
import { MdAdsClick, MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Authority from "../../components/Authority/Authority";
import checkStatusUser from "../../config/UnAuthenticated";
import articleService from "../../services/adminService/ArticleAdminService";
import categoryService from "../../services/adminService/CateAdminService";
const { RangePicker } = DatePicker;

const Articles = () => {
    const [loading, setLoading] = useState(false);
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [priority, setPriority] = useState(1);
    const [status, setStatus] = useState(1);
    const [dataCates, setDataCates] = useState([]);
    const [articleID, setArticleID] = useState(null);
    const [img, setImg] = useState(null);
    const [thumbnail, setThumbnail] = useState(null);
    const [visible, setVisible] = useState(false);
    const [open, setOpen] = useState(false);
    const [data, setData] = useState([]);

    const [titleSearch, setTitleSearch] = useState("");
    const [categoriesSearch, setCategoriesSearch] = useState("");
    const [statusSearch, setStatusSearch] = useState("");

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectStartDate, setSelectStartDate] = useState(null);
    const [selectEndDate, setSelectEndDate] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [selectPage, setSelectPage] = useState(1);
    const [selectLimit, setSelectLimit] = useState(20);

    const [isStatusUser, setIsStatusUser] = useState(false);

    const editorRef = useRef(null);
    const ArticlesRef = useRef(null);
    const navigate = useNavigate();

    const showModalDelete = (id) => {
        setArticleID(id);
        setVisible(true);
    };

    const handleCancelDelete = () => {
        setVisible(false);
    };

    const showModal = () => {
        setOpen(true);
    };
    const handleCancel = () => {
        resetForm();
        setOpen(false);
    };

    const handleChangePriority = (value) => {
        setPriority(value);
    };
    const handleChangeStatus = (value) => {
        setStatus(value);
    };

    const formik = useFormik({
        initialValues: {
            title: "",
            description: "",
            content: "",
            category: "",
        },
        validationSchema: Yup.object({
            title: Yup.string().required("Vui lòng điền tiêu đề"),
            description: Yup.string().required("Vui lòng điền mô tả"),
            content: Yup.string().required("Vui lòng điền nội dung"),
            category: Yup.string().required("Vui lòng chọn danh mục"),
        }),
        onSubmit: (values) => {
            const formData = new FormData();
            formData.append("title", values.title);
            formData.append("description", values.description);
            formData.append("content", values.content);
            formData.append("category_id", values.category);
            formData.append("priority", priority);
            formData.append("status", status);
            if (img && img?.name) {
                formData.append("image", img);
            }
            if (thumbnail && thumbnail?.name) {
                formData.append("thumbnail", thumbnail);
            }

            if (articleID) {
                const data = articleService.updatedArticle(formData, articleID);
                data.then((res) => {
                    if (res?.status === 200) {
                        toast.success(res?.message);
                        setLoading(false);
                        fetchData();
                        resetForm();
                        handleCancel();
                    } else {
                        toast.warn(res?.message);
                        setLoading(false);
                    }
                }).catch((err) => {
                    setLoading(false);
                    if (checkStatusUser(err?.response?.statusText)) {
                        setIsStatusUser(true);
                    } else {
                        return;
                    }
                });
            } else {
                const data = articleService.createArticle(formData);
                data.then((res) => {
                    if (res?.status === 200) {
                        toast.success(res?.message);
                        setLoading(false);
                        resetForm();
                        fetchData();
                        handleCancel();
                    } else {
                        toast.warn(res?.message);
                        setLoading(false);
                    }
                }).catch((err) => {
                    setLoading(false);
                    if (checkStatusUser(err?.response?.statusText)) {
                        setIsStatusUser(true);
                    } else {
                        return;
                    }
                });
            }
        },
    });

    useEffect(() => {
        try {
            const data = categoryService.getCategoryList();
            data.then((res) => {
                if (res?.status === 200) {
                    setDataCates(res?.data);
                } else {
                    toast.warn(res?.message);
                }
            }).catch((err) => {
                if (checkStatusUser(err?.response?.statusText)) {
                    setIsStatusUser(true);
                } else {
                    return;
                }
            });
        } catch (err) {
            toast.error(err);
        }
    }, []);

    useEffect(() => {
        try {
            if (articleID) {
                const data = articleService.getArticle(articleID);
                data.then((res) => {
                    if (res?.status === 200) {
                        const data = res?.data;
                        formik.setValues({
                            title: data.title,
                            description: data.description,
                            content: data.content,
                            category: data.category_id,
                        });
                        setThumbnail(data.thumbnail_url);
                        setImg(data.image);
                        setPriority(data.priority);
                        setStatus(data.status);
                    } else {
                        toast.warn(res?.message);
                    }
                }).catch((err) => {
                    if (checkStatusUser(err?.response?.statusText)) {
                        setIsStatusUser(true);
                    } else {
                        return;
                    }
                });
            }
        } catch (err) {
            toast.error(err);
        }
    }, [articleID]);

    const handleDetailArticle = (id) => {
        setArticleID(id);
        showModal();
    };

    const resetForm = () => {
        formik.resetForm();
        setPriority(1);
        setStatus(1);
        setImg(null);
        setThumbnail(null);
        setArticleID(null);
    };
    const handleDeleteArticle = () => {
        try {
            const data = articleService.deletedArticle(articleID);
            data.then((res) => {
                if (res?.status === 200) {
                    toast.success(res?.message);
                    setVisible(false);
                    fetchData();
                    resetForm();
                } else {
                    toast.warn(res?.message);
                }
            }).catch((err) => {
                if (checkStatusUser(err?.response?.statusText)) {
                    setIsStatusUser(true);
                } else {
                    return;
                }
            });
        } catch (err) {
            toast.error(err);
        }
    };

    const columns = [
        {
            title: "STT",
            dataIndex: "key",
            key: "key",
        },
        {
            title: "Tiêu đề",
            dataIndex: "title",
            key: "title",
        },
        {
            title: "Danh mục",
            dataIndex: "category",
            key: "category",
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            render: (status) => {
                const tag = +status === 1 ? "Hoạt động" : "Không hoạt động";
                const color = +status === 1 ? "green" : "volcano";
                return (
                    <Tag color={color} key={tag}>
                        {tag.toUpperCase()}
                    </Tag>
                );
            },
        },
        {
            title: "Ưu tiên",
            dataIndex: "priority",
            key: "priority",
            render: (priority) => {
                const tag = +priority === 1 ? "Ưu tiên" : "Không ưu tiên";
                const color = +priority === 1 ? "green" : "volcano";
                return (
                    <Tag color={color} key={tag}>
                        {tag.toUpperCase()}
                    </Tag>
                );
            },
        },
        {
            title: "Ngày tạo",
            dataIndex: "created_at",
            key: "created_at",
        },
        {
            title: "Ngày cập nhật",
            dataIndex: "updated_at",
            key: "updated_at",
        },
        {
            title: "Tác giả",
            dataIndex: "author",
            key: "author",
        },
        {
            title: "Xem chi tiết",
            dataIndex: "detail",
            align: "center",
            key: "detail",
            render: (id) => {
                return (
                    <div className="d-flex gap-3">
                        <Tooltip placement="top" title={"Xóa"}>
                            <MdDelete className="fs-4 text-danger" style={{ cursor: "pointer" }} onClick={() => showModalDelete(id)} />
                        </Tooltip>
                        <Tooltip placement="top" title={"Xem chi tiết bài viết"}>
                            <FaRegEye className="fs-4 text-info" style={{ cursor: "pointer" }} onClick={() => handleDetailArticle(id)} />
                        </Tooltip>
                    </div>
                );
            },
        },
    ];
    useEffect(() => {
        fetchData();
    }, [selectPage, selectLimit]);

    const fetchData = async (params = {}) => {
        try {
            const data = articleService.getArticles({ ...params, page: selectPage, limit: selectLimit });
            data.then((res) => {
                if (res?.status === 200) {
                    setData(res?.data);
                    setCurrentPage(res?.current_page);
                    setPerPage(res?.per_page);
                    setTotalRecords(res?.total_records);
                    setLoading(false);
                    setLoadingSearch(false);
                    if (Object.keys(params).length !== 0) {
                        ArticlesRef.current.scrollIntoView({ behavior: "smooth" });
                    }
                } else {
                    toast.warn(res?.message);
                    setLoading(false);
                    setLoadingSearch(false);
                }
            }).catch((err) => {
                setLoadingSearch(false);
                setLoading(false);
                if (checkStatusUser(err?.response?.statusText)) {
                    setIsStatusUser(true);
                }
                return;
            });
        } catch (err) {
            setLoading(false);
            toast.error(err);
        }
    };

    const handleClickSearchArticles = () => {
        setLoadingSearch(true);
        const searchData = {};

        if (titleSearch) {
            searchData.title = titleSearch;
        }
        if (categoriesSearch) {
            searchData.category_id = categoriesSearch;
        }

        if (titleSearch) {
            searchData.title = titleSearch;
        }

        if (statusSearch) {
            searchData.status = statusSearch;
        }
        if (selectStartDate) {
            searchData.start_date = selectStartDate;
        }

        if (selectEndDate) {
            searchData.end_date = selectEndDate;
        }
        fetchData(searchData);
    };

    const handleData = data?.map((item) => {
        const formatDate = (date) => moment.utc(date).format("YYYY-MM-DD HH:mm:ss");
        return {
            ...item,
            created_at: formatDate(item.created_at),
            updated_at: formatDate(item.updated_at),
            author: item.user.name,
            detail: item.id,
        };
    });

    const RedirectToAddArticle = () => {
        resetForm();
        showModal();
    };

    const handlePageChange = (page) => {
        setSelectPage(page);
    };

    const handleRangePickerChange = (dates, dateStrings) => {
        if (dates && dates?.length === 2) {
            setStartDate(dates[0]);
            setEndDate(dates[1]);
            setSelectStartDate(dateStrings[0]);
            setSelectEndDate(dateStrings[1]);
        } else {
            if (dates === null) {
                setStartDate(null);
                setEndDate(null);
                setSelectStartDate(null);
                setSelectEndDate(null);
            }
        }
    };

    const handleOkCheckStatusUser = () => {
        setIsStatusUser(false);
        localStorage.clear();
        navigate("/admin/login");
    };

    const handleEditorChange = (content, editor) => {
        formik.setFieldValue("content", content);
    };

    const handleFilePicker = (cb) => {
        const input = document.createElement("input");
        input.setAttribute("type", "file");
        input.setAttribute("accept", "image/*");
        input.addEventListener("change", (e) => {
            const file = e.target.files[0];
            if (file.size > 100 * 1024) {
                toast.warn("File quá lớn. Vui lòng chọn một file có kích thước nhỏ hơn 100KB.");
                return;
            }
            const reader = new FileReader();
            reader.addEventListener("load", () => {
                cb(reader.result, { title: file.name });
            });
            reader.readAsDataURL(file);
        });

        input.click();
    };

    return (
        <>
            <div className="p-3">
                {isStatusUser && <Authority oke={handleOkCheckStatusUser} status={isStatusUser} />}

                <Card
                    title="TÌM KIẾM BÀI VIẾT"
                    extra={
                        <Button type="primary" style={{ width: "135px" }} onClick={handleClickSearchArticles}>
                            {loadingSearch ? (
                                <div className="spinner-border spinner-border-sm" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            ) : (
                                <span className="fw-bold f-flex align-items-center">
                                    <MdAdsClick className="me-2 fs-5" />
                                    Tìm kiếm
                                </span>
                            )}
                        </Button>
                    }
                    bordered={false}
                >
                    <div className="d-flex gap-5">
                        <div style={{ width: "350px" }}>
                            <label htmlFor="title" className="fw-bolder text-secondary mb-1">
                                Tiêu đề
                            </label>
                            <Input
                                className="form-control d-flex"
                                placeholder="Nhập tiêu đề bài viết cần tìm tại đây ..."
                                id="title"
                                aria-describedby="emailHelp"
                                onChange={(e) => setTitleSearch(e.target.value)}
                                value={titleSearch}
                                allowClear
                            />
                        </div>

                        <div className="d-flex flex-column" style={{ width: "180px" }}>
                            <label htmlFor="title" className="fw-bolder text-secondary mb-1">
                                Loại danh mục <span className="text-danger">*</span>
                            </label>
                            <Select
                                value={categoriesSearch}
                                size="large"
                                onChange={(value) => setCategoriesSearch(value)}
                                options={[{ value: "", label: "Tất cả" }, ...dataCates?.map((cate) => ({ value: cate.id, label: cate.title }))]}
                            />
                        </div>
                        <div className="d-flex flex-column" style={{ width: "180px" }}>
                            <label htmlFor="status" className="fw-bolder text-secondary mb-1">
                                Trạng thái
                            </label>
                            <Select
                                defaultValue={statusSearch}
                                id="status"
                                size="large"
                                onChange={(value) => setStatusSearch(value)}
                                options={[
                                    {
                                        value: "",
                                        label: "Tất cả",
                                    },
                                    {
                                        value: 1,
                                        label: "Hoạt động",
                                    },
                                    {
                                        value: 2,
                                        label: "Không hoạt động",
                                    },
                                ]}
                            />
                        </div>
                        <div className="d-flex flex-column">
                            <label htmlFor="date" className="fw-bolder text-secondary mb-1">
                                Ngày/Tháng/Năm
                            </label>
                            <RangePicker
                                size="large"
                                id={"date"}
                                onChange={handleRangePickerChange}
                                value={[startDate, endDate]}
                                format="DD/MM/YYYY"
                                placeholder={["Ngày bắt đầu", "Ngày kết thúc"]}
                                className="fs-6"
                            />
                        </div>
                    </div>
                </Card>
            </div>
            <Modal title="Xác nhận xóa" open={visible} onCancel={handleCancelDelete} onOk={handleDeleteArticle} okText="Xác nhận" cancelText="Hủy">
                <p>Bạn có chắc chắn muốn xóa bài viết này không?</p>
            </Modal>
            <Modal
                title={!!articleID ? "XEM VÀ CẬP NHẬT BÀI VIẾT" : " TẠO BÀI VIẾT"}
                open={open}
                width={"70%"}
                footer={[null, <Button onClick={handleCancel}>Đóng</Button>]}
                onCancel={handleCancel}
            >
                <div className="p-2">
                    <form method="POST" onSubmit={formik.handleSubmit}>
                        <div className="d-flex gap-4">
                            <div className="mb-3">
                                <label htmlFor="title" className="text-label">
                                    Tiêu đề <span className="text-danger">*</span>
                                </label>
                                <textarea
                                    type="text"
                                    rows="3"
                                    cols="100"
                                    className="form-control fs-6 px-3 text-error"
                                    id="title"
                                    placeholder="Thêm tiêu đề bài viết tại đây ..."
                                    aria-describedby="titleHelp"
                                    onChange={formik.handleChange("title")}
                                    onBlur={formik.handleBlur("title")}
                                    value={formik.values.title}
                                />
                                <div id="titleHelp" className="form-text text-danger ps-1">
                                    {formik.touched.title && formik.errors.title ? formik.errors.title : null}
                                </div>
                            </div>
                            <div className="mb-2">
                                <label htmlFor="desc" className="text-label">
                                    Mô tả <span className="text-danger">*</span>
                                </label>
                                <textarea
                                    type="text"
                                    rows="3"
                                    cols="100"
                                    className="form-control fs-6 px-3 text-error"
                                    id="desc"
                                    placeholder="Thêm mô tả bài viết tại đây ..."
                                    aria-describedby="descHelp"
                                    onChange={formik.handleChange("description")}
                                    onBlur={formik.handleBlur("description")}
                                    value={formik.values.description}
                                />
                                <div id="descHelp" className="form-text text-danger ps-1">
                                    {formik.touched.description && formik.errors.description ? formik.errors.description : null}
                                </div>
                            </div>
                        </div>
                        <div className="mb-4">
                            <label htmlFor="content" className="text-label">
                                Nội dung <span className="text-danger">*</span>
                            </label>
                            <Editor
                                id="content"
                                value={formik.values.content}
                                apiKey={process.env.REACT_APP_KEY_TINY}
                                onInit={(evt, editor) => (editorRef.current = editor)}
                                init={{
                                    branding: false ,
                                    plugins:
                                        "anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount linkchecker code imagetools",
                                    toolbar:
                                        "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat | code",
                                    setup: function (editor) {
                                        editor.on("change", function () {
                                            formik.setFieldValue("content", editor.getContent());
                                        });
                                    },
                                    file_picker_callback: handleFilePicker,
                                }}
                                onEditorChange={handleEditorChange}
                            />

                            <div id="descriptionHelp" className="form-text text-danger ps-1">
                                {formik.touched.content && formik.errors.content ? formik.errors.content : null}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-5 col-12">
                                <div className="mb-3 d-flex flex-column">
                                    <label htmlFor="title" className="text-label">
                                        Loại danh mục <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                        value={formik.values.category || "Lựa chọn danh mục"}
                                        size="large"
                                        onChange={(value) => {
                                            formik.setFieldValue("category", value);
                                        }}
                                        onBlur={formik.handleBlur("category")}
                                        options={dataCates?.map((cate) => ({ value: cate.id, label: cate.title }))}
                                        id="categoryHelp"
                                    />
                                    <div id="categoryHelp" className="form-text text-danger ps-1">
                                        {formik.touched.category && formik.errors.category ? formik.errors.category : null}
                                    </div>
                                </div>
                                <div className="mb-3 d-flex flex-column">
                                    <label htmlFor="priority" className="text-label">
                                        Độ ưu tiên
                                    </label>
                                    <Select
                                        value={priority}
                                        size="large"
                                        id="priority"
                                        onChange={handleChangePriority}
                                        options={[
                                            {
                                                value: 1,
                                                label: "Ưu tiên",
                                            },
                                            {
                                                value: 2,
                                                label: "Không ưu tiên",
                                            },
                                        ]}
                                    />
                                </div>
                                <div className="d-flex flex-column">
                                    <label htmlFor="status" className="text-label">
                                        Trạng thái
                                    </label>
                                    <Select
                                        value={status}
                                        size="large"
                                        id="status"
                                        onChange={handleChangeStatus}
                                        options={[
                                            {
                                                value: 1,
                                                label: "Hoạt động",
                                            },
                                            {
                                                value: 2,
                                                label: "Không hoạt động",
                                            },
                                        ]}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-7 col-12 mt-3 mt-lg-0">
                                <div className="row">
                                    <div className="col-6">
                                        <label htmlFor="image" className="text-label">
                                            Ảnh chính <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="file"
                                            className="form-control fs-6 text-error"
                                            id="image"
                                            onChange={(event) => {
                                                setImg(event.currentTarget.files[0]);
                                            }}
                                        />
                                        <div className="mt-2">
                                            {img ? (
                                                <Image width={"100%"} src={img?.name ? URL.createObjectURL(img) : img} style={{ height: "auto" }} />
                                            ) : (
                                                <Image
                                                    width={"100%"}
                                                    height={"auto"}
                                                    fallback="data:image/png;base64,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"
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <label htmlFor="thumbnail" className="text-label">
                                            Ảnh phụ <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="file"
                                            className="form-control fs-6 text-error"
                                            id="thumbnail"
                                            onChange={(event) => {
                                                setThumbnail(event.currentTarget.files[0]);
                                            }}
                                        />
                                        <div className="mt-2">
                                            {thumbnail ? (
                                                <Image
                                                    width={"100%"}
                                                    src={thumbnail?.name ? URL.createObjectURL(thumbnail) : thumbnail}
                                                    style={{ height: "auto" }}
                                                    className="boder"
                                                />
                                            ) : (
                                                <Image
                                                    width={"100%"}
                                                    height={"auto"}
                                                    fallback="data:image/png;base64,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"
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button
                            className="btn mt-5"
                            type="submit"
                            style={{ width: "200px", height: "40px", backgroundColor: "#1677ff", color: "#fff" }}
                        >
                            {loading ? (
                                <div className="spinner-border spinner-border-sm" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            ) : (
                                <span className="text-white fw-bold"> {!!articleID ? "Cập Nhật Bài Viết" : "Tạo Bài Viết"} </span>
                            )}
                        </button>
                    </form>
                </div>
            </Modal>

            <div ref={ArticlesRef} className="p-3">
                <Card
                    title="DANH SÁCH BÀI VIẾT"
                    extra={
                        <Button type="primary" className="fw-bold f-flex align-items-center" onClick={RedirectToAddArticle}>
                            <FaPlus style={{ marginTop: "1px" }} className="me-2 mb-1 fs-6" />
                            <span> Tạo Bài Viết</span>
                        </Button>
                    }
                    bordered={false}
                >
                    <Table
                        columns={columns}
                        dataSource={handleData?.map((item, index) => ({
                            ...item,
                            status: item.status,
                            category: item.category?.title,
                            key: index + 1 + (currentPage - 1) * perPage,
                        }))}
                        pagination={{
                            current: currentPage,
                            pageSize: perPage,
                            total: totalRecords,
                            showSizeChanger: true,
                            onChange: handlePageChange,
                            onShowSizeChange: (current, size) => {
                                setCurrentPage(current);
                                setPerPage(size);
                                setSelectLimit(size);
                            },
                        }}
                    />
                </Card>
            </div>
        </>
    );
};

export default Articles;
